import { createFileRoute, Outlet } from '@tanstack/react-router';

import { ErrorBoundary } from '../../components/ErrorBoundary.jsx';

export const Route = createFileRoute('/recommendation')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  );
}
